/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Judge0Response
 */
export interface Judge0Response {
    /**
     * 
     * @type {string}
     * @memberof Judge0Response
     */
    compile_output: string | null;
    /**
     * 
     * @type {string}
     * @memberof Judge0Response
     */
    stdout: string | null;
    /**
     * 
     * @type {string}
     * @memberof Judge0Response
     */
    stderr: string | null;
}

/**
 * Check if a given object implements the Judge0Response interface.
 */
export function instanceOfJudge0Response(value: object): value is Judge0Response {
    if (!('compile_output' in value) || value['compile_output'] === undefined) return false;
    if (!('stdout' in value) || value['stdout'] === undefined) return false;
    if (!('stderr' in value) || value['stderr'] === undefined) return false;
    return true;
}

export function Judge0ResponseFromJSON(json: any): Judge0Response {
    return Judge0ResponseFromJSONTyped(json, false);
}

export function Judge0ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): Judge0Response {
    if (json == null) {
        return json;
    }
    return {
        
        'compile_output': json['compile_output'],
        'stdout': json['stdout'],
        'stderr': json['stderr'],
    };
}

export function Judge0ResponseToJSON(json: any): Judge0Response {
    return Judge0ResponseToJSONTyped(json, false);
}

export function Judge0ResponseToJSONTyped(value?: Judge0Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'compile_output': value['compile_output'],
        'stdout': value['stdout'],
        'stderr': value['stderr'],
    };
}

